export const table_titles = [
	{ name: "#", size: 3, order: "" },
	{ name: "Título", size: 30, order: "incidents_title" },
	{ name: "Fecha de Creación", size: 10, order: "creation_date" },
	{ name: "Estado", size: 5, order: "status_name" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_incident = {
	title: "",
	description: "",
	solution: "",
	status_id: "",
	customer_id: [],
	files: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
